export default {
    INVALID_DATA: 'Неверные данные о крафте, пожалуйста, отправьте сообщение об ошибке.',
    INVALID_ITEM: 'Выбран неверный элемент.',
    INVALID_ITEMS: 'У вас нет необходимых предметов для его создания.',
    SELECT_ITEM: 'Пожалуйста, выберите предмет для изготовления.',
    FAILED_CRAFT: 'Вам не удалось создать. {{failedText}}'
} as const;
